/**
 * @generated SignedSource<<1c8c3b5f65b11cb519ee6e295de0e600>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedProductTileCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTilesCarousel_user">;
  readonly " $fragmentType": "PdpSharedProductTileCarousel_user";
};
export type PdpSharedProductTileCarousel_user$key = {
  readonly " $data"?: PdpSharedProductTileCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedProductTileCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemTilesCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5cf807bc1fcc41e8c26953411c8df3a4";

export default node;
